var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentMethods(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#53B175"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.6316V11.1908H9V12.6316H21ZM21 14.0724H9V18.3948H21V14.0724ZM9 9.75H21C21.3978 9.75 21.7794 9.9018 22.0607 10.172C22.342 10.4422 22.5 10.8087 22.5 11.1908V18.3948C22.5 18.777 22.342 19.1434 22.0607 19.4136C21.7794 19.6838 21.3978 19.8356 21 19.8356H9C8.60218 19.8356 8.22064 19.6838 7.93934 19.4136C7.65804 19.1434 7.5 18.777 7.5 18.3948V11.1908C7.5 10.8087 7.65804 10.4422 7.93934 10.172C8.22064 9.9018 8.60218 9.75 9 9.75ZM10.5 15.5132H11.25C11.4489 15.5132 11.6397 15.5891 11.7803 15.7242C11.921 15.8593 12 16.0426 12 16.2336C12 16.4247 11.921 16.6079 11.7803 16.743C11.6397 16.8781 11.4489 16.954 11.25 16.954H10.5C10.3011 16.954 10.1103 16.8781 9.96967 16.743C9.82902 16.6079 9.75 16.4247 9.75 16.2336C9.75 16.0426 9.82902 15.8593 9.96967 15.7242C10.1103 15.5891 10.3011 15.5132 10.5 15.5132ZM14.25 15.5132H18C18.1989 15.5132 18.3897 15.5891 18.5303 15.7242C18.671 15.8593 18.75 16.0426 18.75 16.2336C18.75 16.4247 18.671 16.6079 18.5303 16.743C18.3897 16.8781 18.1989 16.954 18 16.954H14.25C14.0511 16.954 13.8603 16.8781 13.7197 16.743C13.579 16.6079 13.5 16.4247 13.5 16.2336C13.5 16.0426 13.579 15.8593 13.7197 15.7242C13.8603 15.5891 14.0511 15.5132 14.25 15.5132Z",
    fill: "#53B175"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethods);
export default __webpack_public_path__ + "static/media/PaymentMethods.f39409809621100d4a0d1db743117dbc.svg";
export { ForwardRef as ReactComponent };